import _ from 'underscore'

import React from 'react'
import styled from 'styled-components'

import Table from 'components/Table'

import Stage from 'pages/Device/ThermostatRthPanel/Cycles/Stage'
import { OPERATIONS } from 'pages/Device/ThermostatRthPanel/Chart/rthDataParser'

import { Accessories, stage } from 'types/RuntimeHistory'

type props = {
  stages: Array<stage>
  accessories: Accessories
}

const Cycles = ({ stages, accessories }: props) => {
  const indoorItemRegex = /(indoor|ids)/i
  const outdoorStages = _.filter(stages, (stage) => !OPERATIONS[stage.stage].category.match(indoorItemRegex))
  const indoorStages = _.filter(stages, (stage) => OPERATIONS[stage.stage].category.match(indoorItemRegex))
  const availableAccessories = _.pick(accessories, item => !_.isEmpty(item))

  return (
    <S.Cycles aria-label="cycle-count-history">
      <Table items={[...stages, availableAccessories]} noDataMessage={{ title: '', description: '' }}>
        <Table.Header>
          <S.CycleCountHistoryHeaderCell title="Cycle Count History" />
          <Table.HeaderCell title="Cycle Count" />
          <Table.HeaderCell title="Run Time Mins" />
        </Table.Header>
        <div>
          {!_.isEmpty(outdoorStages) && <S.CategoryRow>Outdoor</S.CategoryRow>}
          {_.map(outdoorStages, (stage) => <Stage key={stage.stage} stage={stage} />)}
          {!_.isEmpty(indoorStages) && <S.CategoryRow>Indoor</S.CategoryRow>}
          {_.map(indoorStages, (stage) => <Stage key={stage.stage} stage={stage} />)}
          {!_.isEmpty(availableAccessories) && <S.CategoryRow>Accessories</S.CategoryRow>}
          {_.map(_.keys(availableAccessories), item => <Stage key={item} stage={availableAccessories[item]} />)}
        </div>
      </Table>
    </S.Cycles>
  )
}

export default Cycles

const S = {
  Cycles: styled.div`
    padding: 20px;
  `,
  CategoryRow: styled(Table.Row)`
    font-weight: bold;
    padding: 10px;
  `,
  CycleCountHistoryHeaderCell: styled(Table.HeaderCell)`
    flex: 2;
  `
}
